export enum PlayerMessageType {
    TimeChange = "time_change"
}

//union messageType
export interface IPostMessage {
    messageType: PlayerMessageType;
    msg: any;
}

export interface MsgWithEvent<T> {
    msg: T;
    event: MessageEvent;
}


export class PostMessageUtil {

    private static ProtoHostRegex = /(\w{3,}):\/\/(.+?)(?:\/.*)?$/;

    private hasSupport(): boolean {
        return document.referrer !== null && document.referrer !== '';
    }

    private static getParentOrigin(): string {
        const matches = this.ProtoHostRegex.exec(document.referrer);
        const targetOrigin = (matches !== null && matches.length == 3) ? matches[1] + '://' + matches[2] : '';
        return targetOrigin;
    }

    static registerListener(fn: (msgEvent: MessageEvent) => void) {
        window.addEventListener("message", fn, false)
    }

    static removeListener(fn: (evt: MessageEvent) => void) {
        window.removeEventListener("message", fn, false)
    }

    static sendTo(msg: IPostMessage, target: Window, origin: string): void {
        target.postMessage(msg, origin);
    }

    static sendToParent(msg: IPostMessage): void {
        const targetOrigin = this.getParentOrigin();

        if (targetOrigin !== '')
            window.parent.postMessage(msg, targetOrigin);
    }

}